function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 16,
  fill: "#A649FD"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#A649FD",
  fillOpacity: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 23v-5a1 1 0 10-2 0v5h-5a1 1 0 100 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5z",
  fill: "#fff"
});

function SvgPromoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMTYiIGZpbGw9IiNBNjQ5RkQiLz4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNBNjQ5RkQiIGZpbGwtb3BhY2l0eT0iMC4zIi8+CjxwYXRoIGQ9Ik0yNSAyM1YxOEMyNSAxNy40NDc3IDI0LjU1MjMgMTcgMjQgMTdDMjMuNDQ3NyAxNyAyMyAxNy40NDc3IDIzIDE4VjIzSDE4QzE3LjQ0NzcgMjMgMTcgMjMuNDQ3NyAxNyAyNEMxNyAyNC41NTIzIDE3LjQ0NzcgMjUgMTggMjVIMjNWMzBDMjMgMzAuNTUyMyAyMy40NDc3IDMxIDI0IDMxQzI0LjU1MjMgMzEgMjUgMzAuNTUyMyAyNSAzMFYyNUgzMEMzMC41NTIzIDI1IDMxIDI0LjU1MjMgMzEgMjRDMzEgMjMuNDQ3NyAzMC41NTIzIDIzIDMwIDIzSDI1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgPromoIcon as ReactComponent };